import { MatDialogRef } from '@angular/material';
import { Component, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-activity-dialog',
  templateUrl: './activity-dialog.component.html',
  styleUrls: ['./activity-dialog.component.scss']
})
export class ActivityDialogComponent {

  onYes = new EventEmitter();
  onNo = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<ActivityDialogComponent>) { }

  closeDialog() {
    this.dialogRef.close();
  }

  yesClicked() {
    this.onYes.emit();
    this.dialogRef.close();
  }

  noClicked() {
    sessionStorage.removeItem('checkboxValues');
    sessionStorage.removeItem('activities');
    this.onNo.emit();
    this.dialogRef.close();
  }

}
